import { Component, Input } from '@angular/core';
import { Injectable }     from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { AppService } from '../../app.service';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';


@Injectable()
export class SalesService {
    
    // private serviceURI = 'data/forecast/';
    private serviceURI = 'maps/bank/';
    constructor(private apiservice :AppService,private http: Http) {
    }
    getSummary(): Observable<any[]> {
        return this.apiservice.get(`${this.serviceURI}summary`);
    }
    getSalesForecast(): Observable<any[]> {
        return this.apiservice.get(`${this.serviceURI}forecast`);
    }
    getHistorical(): Observable<any[]> {
        return this.apiservice.get(`${this.serviceURI}history`);
    }
    getFilter(): Observable<any[]>  {      
        return this.apiservice.post(`${this.serviceURI}filter`,{
            "city" :"karachi",
        });
  }
  getALLBranch(): Observable<any[]>  {      
    return this.apiservice.post(`${this.serviceURI}allbranchdata`,{
        "b_id":"all",
        "section":"all",
        "city": "Karachi"
    });
}
getBranchData(bId :string,section :string): Observable<any[]>  {      
    return this.apiservice.post(`${this.serviceURI}branchdata`,{
            "b_id":bId,
            "section":section,
            "city": "Karachi"
        
    });
}

}




// WEBPACK FOOTER //
// ./src/app/home-page/sales-forecast/sales-service.service.ts